import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { dynamicBaseQuery } from "./dynamicBaseQuery.js";
import { api } from "../../Appjs/api.js";

export const smsApi = createApi({
  reducerPath: "smsApi",
  // baseQuery: dynamicBaseQuery,
  baseQuery: fetchBaseQuery({
    baseUrl: api,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem("accessToken");
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  tagTypes: ["SmsUploads"],

  endpoints: (builder) => ({
    fetchSmsUploadIds: builder.query({
      query: ({ from, to }) => `/sms/get/smsupload_id?from=${from}&to=${to}`,
    }),

    fetchSmsUploadData: builder.query({
      query: ({ startdate, enddate, file_status, page = 1, limit = 25 }) => {
        const params = new URLSearchParams();
        if (startdate) params.append("startdate", startdate);
        if (enddate) params.append("enddate", enddate);
        if (file_status) params.append("file_status", file_status);
        params.append("page", page);
        params.append("limit", limit);
        return `/sms/get-sms-upload-data?${params.toString()}`;
      },
    }),

    deleteSmsUpload: builder.mutation({
      query: ({ smsupload_id }) => ({
        url: `/sms/delete/${smsupload_id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["SmsUploads"],
    }),

    getAssignedService: builder.query({
      query: () => ({
        url: ``,
        method: "GET",
      }),
    }),

    uploadBulkSMS: builder.mutation({
      query: (data) => ({
        url: "/sms/uploadfile",
        method: "POST",
        body: data,
      }),
    }),

    uploadSplitSMS: builder.mutation({
      query: (data) => ({
        url: "/sms/split/shedule",
        method: "POST",
        body: data,
      }),
    }),

    uploadComposeSMS: builder.mutation({
      query: (data) => ({
        url: "/sms/upload/compose",
        method: "POST",
        body: data,
      }),
    }),

    uploadCustomize: builder.mutation({
      query: (data) => ({
        url: "/sms/upload-custom-sms",
        method: "POST",
        body: data,
      }),
    }),

    checkSpamKeywords: builder.query({
      query: (smstext) =>
        `/sms/check-spam-keywords?smstext=${encodeURIComponent(smstext)}`,
      transformResponse: (response) => {
        if (!response) {
          return {
            status: false,
            message: "No response from server",
            data: [],
          };
        }
        return response;
      },
    }),

    previewData: builder.mutation({
      query: (formdata) => ({
        url: "/sms/sp-counts-upload",
        method: "POST",
        body: formdata,
      }),
    }),

    previewcomposeData: builder.mutation({
      query: (formdata) => ({
        url: "/sms/sp-counts-composeSms",
        method: "POST",
        body: formdata,
      }),
    }),

    previewcustomizeData: builder.mutation({
      query: (formdata) => ({
        url: "/sms/customize-file/counts",
        method: "POST",
        body: formdata,
      }),
    }),
    smsdlrurlpost:builder.mutation({
      query:(smspayload) => ({
        url:'/webhook/customer-dlr-url',
        method: "POST",
        body: smspayload
      })
    }),
    smsdlrurlget:builder.query({
      query:() =>({
        url:`/webhook/customer-dlr-url`
      })
    }),
    smsdlrurldlt:builder.mutation({
      query:(customerDlrUrl_id) =>({
        url:`/webhook/customer-dlr-url/${customerDlrUrl_id}`,
        method:"DELETE",
      })
    }),
    smsdlrurlput:builder.mutation({
      query:({customerDlrUrl_id,smspayload}) =>({
        url:`/webhook/customer-dlr-url/${customerDlrUrl_id}`,
        method:"PUT",
        body: smspayload
      })
    }),
    getsmsapisentreport:builder.query({
      query:({start_date,end_date,page,limit})=>({
        url:`/customer/get/customer-api-sms-requests?startdate=${start_date}&enddate=${end_date}&page=${page}&limit=${limit}`,
        method:"GET"
      })
    }),
    getsmsapireportcount:builder.query({
      query:({start_date,end_date})=>({
        url:`/customer/get-customer-api-sms-delivery-status-count?startdate=${start_date}&enddate=${end_date}`,
        method:"GET"
      })
    }),
    getsmsapisentdetail:builder.query({
      query:({request_id,})=>({
        url:`customer/get/customer-api-sms-numbers?gateway_request_id=${request_id}&page=1&limit=25`,
        method:"GET",
      })
    })
  }),
});

export const {
  useLazyFetchSmsUploadIdsQuery,
  useFetchSmsUploadIdsQuery,
  useFetchSmsUploadDataQuery,
  useDeleteSmsUploadMutation,
  useUploadBulkSMSMutation,
  useUploadSplitSMSMutation,
  useUploadComposeSMSMutation,
  useUploadCustomizeMutation,
  useLazyCheckSpamKeywordsQuery,
  usePreviewDataMutation,
  usePreviewcomposeDataMutation,
  usePreviewcustomizeDataMutation,
  useSmsdlrurlpostMutation,
  useSmsdlrurlgetQuery,
  useSmsdlrurldltMutation,
  useSmsdlrurlputMutation,
  useGetsmsapireportcountQuery,
  useGetsmsapisentreportQuery,
  useGetsmsapisentdetailQuery
} = smsApi;
